<template>
  <ion-page>
    <master-layout @refreshPage="reRender" pageTitle="افزودن مشتری جدید">
      <Loading v-if="!loaded"></Loading>
      <AjaxForm v-if="loaded" route="customer/Add">
        <ion-card>
          <ion-card-content>

            <div class="mb-2">
              <label>نام کامل</label>
              <input type="text" name="fullname" class="form-control">
            </div>

            <div class="mb-2">
              <label>عنوان</label>
              <input type="text" name="title" class="form-control">
            </div>

            <div class="mb-2">
              <label>تلفن همراه</label>
              <input type="tel" name="phone" class="form-control">
            </div>

            <div class="mb-2">
              <label>تاریخ تولد</label>
              <date-input name="birth_date" ></date-input>
            </div>

            <div class="mb-2">
              <label>کد ملی</label>
              <input type="text" name="national_code" class="form-control">
            </div>

            <div class="mb-2">
              <label>ایمیل</label>
              <input name="email" type="email" class="form-control">
            </div>

            <div class="mb-2">
              <label>تلفن ثابت</label>
              <input type="text" name="u_telephone" class="form-control">
            </div>

            <div class="mb-2">
              <label>استان</label>
              <select autocomplete="off" class="form-control" @change="getCities($event)" name="state_id">
                <option value="0" disabled selected>لطفا استان مورد نظر را انتخاب نمایید</option>
                <option :key="state._id" v-for="state in states" :value="state._id">{{ state.title }}</option>
              </select>
            </div>

            <div class="mb-2">
              <label>شهر</label>
              <div class="city_div">
                <select name="city_id" data-title="استان را انتخاب کنید" class="form-control">
                  <option :key="city._id" v-for="city in cities" :value="city._id">{{ city.title }}</option>
                </select>
              </div>
            </div>

            <ExtraField v-for="item in extraFields" :key="item" :item="item"></ExtraField>
            <div class="mb-2">
              <label>آدرس</label>
              <textarea name="address" class="form-control"></textarea>
            </div>


            <div id="map_div" class="mt-2" ref="map_div">
              <div id="map3"></div>
            </div>
            <input type="hidden" name="lat" v-model="lat" readonly>
            <input type="hidden" name="lng" v-model="lng" readonly>

            <button class="btn btn-success btn-block">ثبت اطلاعات مشتری</button>
          </ion-card-content>
        </ion-card>

      </AjaxForm>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage,IonCard,IonCardContent} from '@ionic/vue';
// import AliAjaxSelect from "@/components/aliAjaxSelect";
import AjaxForm from "@/components/AjaxForm";
import L from "leaflet";
import MasterLayout from "../../components/MasterLayout";
import Loading from "../../components/Loading";
import ExtraField from "../../components/ExtraField";
import DateInput from "@/components/DateInput.vue";

// import {getFormData} from '@/shared/helper'

export default {
  name: "AddWarehouse",
  components: {
    DateInput,
    Loading,
    AjaxForm,MasterLayout,
    IonPage,IonCard,IonCardContent,ExtraField
  },
  data()
  {
    return {
      lat : '',
      loaded : false,
      lng : '',
      states: [],
      cities: [{_id: 0, title: 'ابتدا استان را انتخاب نمایید'}],
      map : null,
      extraFields : [],
    }
  },
  async mounted()
  {
    this.states = await this.getStates();
    const check = await this.getCustomerExtraFields();
    if (check && check.ok)
    {
      this.extraFields = check.fields;
    }
    await this.init();
  },
  methods: {
    ...mapActions("app", {
      getStates: 'getStates',
      getJobs: 'getJobs',
      apiGetCities: 'getCities',
    }),
    ...mapActions('customer',{
      getCustomerExtraFields : 'getCustomerExtraFields'
    }),
    async init()
    {
      const self = this;
      setTimeout(function (){
        self.initMap();
      },500);
      this.loaded = true;
    },
    async getCities(event)
    {
      const result = await this.apiGetCities(event.target.value);
      if (result)
      {
        this.cities = result.cities;
      }
    },
    initMap()
    {
      this.map_html = this.$refs['map_div'];
      this.map_html.innerHTML = '<div id="map3" style="height: 300px"></div>';
      const lat = 36.314571865811935, lng = 59.57267761230469;
      const zoom=12;
      const osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          osmAttrib = '&copy; <a href="https://carencar.com">کارن کار</a>',
          osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib});
      this.map = L.map('map3',{ zoomControl: true, dragging: true, boxZoom: true, scrollWheelZoom: true }).setView([lat,lng], zoom).addLayer(osm);
      L.control.locate({
        drawCircle: true, // controls whether a circle is drawn that shows the uncertainty about the location
        setView: true, // automatically sets the map view to the user's location, enabled if follow is true
        follow:true,
        flyTo:true,
        keepCurrentZoomLevel: false, // keep the current map zoom level when displaying the user's location. (if false, use maxZoom)
        circlePadding: [0, 0], // padding around accuracy circle, value is passed to setBounds
        locateOptions: {
          maxZoom: 15
        },
        strings: {
          title: "نمایش موقعیت فعلی", // title of the locate control
          popup: "موقعیت فعلی شما", // text to appear if user clicks on circle
          outsideMapBoundsMsg: "بنظر میاد شما در خارج از این کره خاکی هستید" // default message for onLocationOutsideMapBounds
        }
      }).addTo(this.map);
      // L.Control.geocoder().addTo(this.map);

      this.map.on('click',(e) =>{
        this.placeMarker(e);
      });

    },
    placeMarker(e)
    {
      try
      {
        if (this.markerHolder)
          this.markerHolder.removeFrom(this.map);
      } catch (e)
      {
        console.log(e);
      }
      const iconUrl = '/assets/img/order-marker.png';
      const markerIcon = new L.Icon({
        iconUrl: iconUrl,
        iconSize:  [30, 46],
        iconAnchor:   [17, 45],
      });
      this.markerHolder = new L.marker(e.latlng,{icon:markerIcon})
      this.markerHolder.addTo(this.map);
      this.lat = e.latlng.lat;
      this.lng = e.latlng.lng;

    },
    reRender()
    {
      this.init();
    }
  }
}

</script>

<style scoped>
#map {
  height: 400px;
  direction: ltr;
}
.mt-2
{
  margin-top: 5px;
}
</style>